// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.currencies-row {
  margin: 100px;
  padding-top: 30px;
}
.currencies-row .currency {
  width: 200px;
}
.currencies-row .currency .currencies-card {
  padding: 15px 15px 30px 15px;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin: 0 0 20px 0;
}
.currencies-row .currency .currencies-card:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.currencies-row .currency .currencies-card .currencies-card-header {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.currencies-row .currency .currencies-card .currencies-card-header .currencies-card-header-title {
  font-size: 1.4rem;
  font-weight: 600;
  text-align: center;
  margin: 0;
  padding: 0;
  color: var(--dark);
}
.currencies-row .currency .currencies-card .currencies-card-header .currencies-card-header-title .currencies-card-symbol {
  font-size: 1.8rem;
  font-weight: bold;
  margin: 0;
  padding: 0;
  color: var(--subscribe);
}
.currencies-row .currency .currencies-card .currencies-card-header .currencies-card-header-rate {
  font-size: 2rem;
  font-weight: 600;
  text-align: center;
  margin: 0;
  padding: 0;
}
.currencies-row .currency .currencies-card .currencies-card-header .currencies-card-header-rate .currencies-card-header-rate-title {
  font-size: 0.8rem;
  font-weight: normal;
  color: var(--subscribe);
}
.currencies-row .currency .currencies-card .hr {
  background: black;
  width: 100%;
  opacity: 0.2;
}
.currencies-row .currency .currencies-card .currencies-card-body .currencies-card-body-options {
  display: flex;
  justify-content: space-between;
}
.currencies-row .currency .currencies-card .currencies-card-body .currencies-card-body-options .edit-btn {
  border-color: transparent;
  color: var(--background);
  background: var(--subscribe);
  font-size: 1rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.currencies-row .currency .currencies-card .currencies-card-body .currencies-card-body-options .delete-btn {
  border-color: transparent;
  color: var(--danger);
  background: var(--white);
  font-size: 1rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.currencies-row .currency .currencies-card .currencies-card-body .currencies-card-body-options .active-btn {
  border-color: transparent;
  color: var(--subscribe);
  background: var(--white);
  font-size: 1rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.currencies-row .currency .currencies-card .ant-col-spin {
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/page/cyrrency.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;AACF;AAAE;EACE,YAAA;AAEJ;AADI;EACE,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,uCAAA;EACA,kBAAA;AAGN;AADM;EACE,uCAAA;AAGR;AAAM;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAER;AAAQ;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AAEV;AAAU;EACE,iBAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AAEZ;AAEQ;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAAV;AAEU;EACE,iBAAA;EACA,mBAAA;EACA,uBAAA;AAAZ;AAKM;EACE,iBAAA;EACA,WAAA;EACA,YAAA;AAHR;AAOQ;EACE,aAAA;EACA,8BAAA;AALV;AAOU;EACE,yBAAA;EACA,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,uCAAA;AALZ;AAQU;EACE,yBAAA;EACA,oBAAA;EACA,wBAAA;EACA,eAAA;EACA,uCAAA;AANZ;AASU;EACE,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,eAAA;EACA,uCAAA;AAPZ;AAYM;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAVR","sourcesContent":[".currencies-row {\n  margin: 100px;\n  padding-top: 30px;\n  .currency {\n    width: 200px;\n    .currencies-card {\n      padding: 15px 15px 30px 15px;\n      border-radius: 5px;\n      overflow: hidden;\n      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n      margin: 0 0 20px 0;\n\n      &:hover {\n        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n      }\n\n      .currencies-card-header {\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n\n        .currencies-card-header-title {\n          font-size: 1.4rem;\n          font-weight: 600;\n          text-align: center;\n          margin: 0;\n          padding: 0;\n          color: var(--dark);\n\n          .currencies-card-symbol {\n            font-size: 1.8rem;\n            font-weight: bold;\n            margin: 0;\n            padding: 0;\n            color: var(--subscribe);\n          }\n        }\n\n        .currencies-card-header-rate {\n          font-size: 2rem;\n          font-weight: 600;\n          text-align: center;\n          margin: 0;\n          padding: 0;\n\n          .currencies-card-header-rate-title {\n            font-size: .8rem;\n            font-weight: normal;\n            color: var(--subscribe);\n          }\n        }\n      }\n\n      .hr {\n        background: black;\n        width: 100%;\n        opacity: .2;\n      }\n\n      .currencies-card-body {\n        .currencies-card-body-options {\n          display: flex;\n          justify-content: space-between;\n\n          .edit-btn {\n            border-color: transparent;\n            color: var(--background);\n            background: var(--subscribe);\n            font-size: 1rem;\n            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n          }\n\n          .delete-btn {\n            border-color: transparent;\n            color: var(--danger);\n            background: var(--white);\n            font-size: 1rem;\n            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n          }\n\n          .active-btn {\n            border-color: transparent;\n            color: var(--subscribe);\n            background: var(--white);\n            font-size: 1rem;\n            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n          }\n        }\n      }\n\n      .ant-col-spin {\n        height: 80%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
